export const SET_TIN_CHAP_EDIT = "SET_TIN_CHAP_EDIT";
export const SET_CONFIG_TM_TIN_CHAP = "SET_CONFIG_TM_TIN_CHAP";
export const SHOW_FORM_TIN_CHAP = "SHOW_FORM_TIN_CHAP";
export const GET_CONFIG_SYS_TMTC = "GET_CONFIG_SYS_TMTC";
export const POST_TIN_CHAP = "POST_TIN_CHAP";
export const POST_TIN_CHAP_SUCCESS = "POST_TIN_CHAP_SUCCESS";
export const POST_TIN_CHAP_FAILURE = "POST_TIN_CHAP_FAILURE";
export const CHECK_EDIT_TIN_CHAP = "CHECK_EDIT_TIN_CHAP";
export const CHECK_EDIT_CUSTOMER_TC = "CHECK_EDIT_CUSTOMER_TC";
export const SET_ENABLE_EDIT_TIN_CHAP = "SET_ENABLE_EDIT_TIN_CHAP";
export const SET_ENABLE_EDIT_CUSTOMER_TC = "SET_ENABLE_EDIT_CUSTOMER_TC";
export const SET_TAI_SAN_TC = "SET_TAI_SAN_TC";
export const GET_TAI_SAN_THEO_CHO_VAY_TMTC = "GET_TAI_SAN_THEO_CHO_VAY_TMTC";
